'use es6';

import { HR } from 'foundations-components/transitional/components/HR';
import { Select } from 'foundations-components/transitional/components/Select';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { Conditions } from '../../../schema/filter-records';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SnowflakeFilterSeparator = ({
  condition = Conditions.AND,
  readOnly,
  onChange
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "20px",
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush",
      marginInline: "300"
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsx(Select, {
        buttonUse: "transparent",
        readOnly: readOnly,
        onChange: ({
          target: {
            value
          }
        }) => onChange(value),
        options: [{
          text: 'and',
          value: Conditions.AND
        }, {
          text: 'or',
          value: Conditions.OR
        }],
        value: condition,
        paddingBlock: "0",
        marginBlock: "0"
      })
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush",
      marginInline: "300"
    })]
  });
};
export default SnowflakeFilterSeparator;